import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import FormattedNumber from '../../../FormattedNumber'

import './style.scss'

export default class Money extends Component {
    static propTypes = {
        currencyStyle: PropTypes.object,
        decimalPlaces: PropTypes.number,
        emptyValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        showCurrency: PropTypes.bool,
        value: PropTypes.object,
        valueStyle: PropTypes.object,
    }

    static defaultProps = {
        value: {},
        showCurrency: true,
    }

    render() {
        const { value, decimalPlaces, showCurrency, emptyValue, valueStyle, currencyStyle } = this.props

        const amount = _.get(value, 'amount', null)

        return (
            <FormattedNumber
                customBase={1}
                value={amount}
                emptyValue={emptyValue}
                currency={value?.currency}
                decimalPlaces={decimalPlaces || 0}
                displayCurrency={showCurrency}
                displayUnits={false}
                valueStyle={valueStyle}
                currencyStyle={currencyStyle}
            />
        )
    }
}
